import React from "react";
import { useLocation, Routes, Route } from "react-router-dom";

// Shared Layouts
import NavBars from "./Component/NavBars";
import Sidebar from "./Component/SideNavBar";

// Auth Pages
import Login from "./Component/Login";
import Signup from "./Component/SignUp";
import ResetPassword from "./Component/Resetpassword";

// =========================  using compoenets ============================================== //

// Main App Pages
import Home from "./Component/Homes";
import Bannerimages from "./Component/Bannerimages";
import SubscriptionsideNav from "./Component/Modules/Subscriptionmanagment/SubscriptionsideNav"
import Foodsubscription from "./Component/Modules/Subscriptionmanagment/Food/Foodsubscription";
import Grocerysubscription from "./Component/Modules/Subscriptionmanagment/Grocery/Grocerysubscription";
import Cateringsubscription from "./Component/Modules/Subscriptionmanagment/Catering/Cateringsubscription";
import Logisticssubscription from "./Component/Modules/Subscriptionmanagment/Logistics/Logisticssubscription";
import Eventssubscription from "./Component/Modules/Subscriptionmanagment/Events/Eventssubscription";
import FoodClient from "./Component/Modules/Clientmanagment/Food/FoodClient";
import Cateringsidebar from "./Component/Modules/Clientmanagment/Cateringsidebar";
import Cateringclient from "./Component/Modules/Clientmanagment/Catering/Cateringclient";
import Cateringregisteterd from "./Component/Modules/Clientmanagment/Catering/Cateringregisteterd";
import Groceryclientmanagement from "./Component/Modules/Clientmanagment/Grocery/Groceryclientmanagement";
import Logisticsclients from "./Component/Modules/Clientmanagment/Logistics/Logisticsclients";
import Eventclient from "./Component/Modules/Clientmanagment/Events/Eventclient";
import Foodorder from "./Component/Modules/Ordermanagment/Food/Foodorder";
import Ordermanagmentsidebar from "./Component/Modules/Ordermanagment/Ordermanagmentsidebar";

import Cateringorders from "./Component/Modules/Ordermanagment/Catering/Cateringorders";
import Groceryorder from "./Component/Modules/Ordermanagment/Grocery/Groceryorder";
import Logisticsandservices from "./Component/Modules/Ordermanagment/Logistics/Logisticsandservices";
import Eventorder from "./Component/Modules/Ordermanagment/Events/Eventorder";
import Userdetails from "./Component/Modules/Usermanagment/Food/Userdetails";
import Usermanagmentsidebar from "./Component/Modules/Usermanagment/Usermanagmentsidebar";
import Userdetailsdata from "./Component/Modules/Usermanagment/Caterings/Userdetailsdata";

import Groceryuserdetails from "./Component/Modules/Usermanagment/Grocery/Groceryuserdetails";
import Logisticsuserdetails from "./Component/Modules/Usermanagment/Logistics/Logisticsuserdetails";
import Foodsetingspage from "./Component/Modules/Accounthistorymanagment/Food/Foodsetingspage";
import Accounthistorysidebar from "./Component/Modules/Accounthistorymanagment/Accounthistorysidebar";
import Cateringsetiingspage from "./Component/Modules/Accounthistorymanagment/Catering/Cateringsetiingspage";
import Groceriessettings from "./Component/Modules/Accounthistorymanagment/Grocery/Groceriessettings";
import Logisticssettings from "./Component/Modules/Accounthistorymanagment/Logistics/Logisticssettings";
import Eventsetingspage from "./Component/Modules/Accounthistorymanagment/Events/Eventsetingspage";
import Foodaccounts from "./Component/Modules/Accountsandhistory/Food/Foodaccounts";
import Foodaccountsidebar from "./Component/Modules/Accountsandhistory/Foodaccountsidebar";
import Eventaccounts from "./Component/Modules/Accountsandhistory/Events/Eventaccounts";
import CateringsAccounts from "./Component/Modules/Accountsandhistory/Caterings/CateringsAccounts";
import GroceryAccounts from "./Component/Modules/Accountsandhistory/Grocery/GroceryAccounts";
import LogisticsAccounts from "./Component/Modules/Accountsandhistory/Logistics/LogisticsAccounts";
import FoodPramotions from "./Component/Modules/Promotionsanddiscounts/Food/FoodPramotions";
import EventPramotions from "./Component/Modules/Promotionsanddiscounts/Events/EventPramotions";
import Promotionssidebar from "./Component/Modules/Promotionsanddiscounts/Promotionssidebar";
import Promotionscaterings from "./Component/Modules/Promotionsanddiscounts/Caterings/Promotionscaterings";
import Promotionsgrocery from "./Component/Modules/Promotionsanddiscounts/Grocery/Promotionsgrocery";
import Logisticspromotions from "./Component/Modules/Promotionsanddiscounts/Logistics/Logisticspromotions";
import Foodcare from "./Component/Modules/Customercaremanagment/Food/Foodcare";
import Eventcare from "./Component/Modules/Customercaremanagment/Events/Eventcare";
import Coustomersidebar from "./Component/Modules/Customercaremanagment/Coustomersidebar";
import Foodreports from "./Component/Modules/ReportandAnalysis/Food/Foodreports";
import Eventreports from "./Component/Modules/ReportandAnalysis/Events/Eventreports";
import Logisticsreports from "./Component/Modules/ReportandAnalysis/Logistics/Logisticsreports";
import Reportsidebar from "./Component/Modules/ReportandAnalysis/Reportsidebar";
import CateringReports from "./Component/Modules/ReportandAnalysis/Caterings/CateringReports";
import Groceryreport from "./Component/Modules/ReportandAnalysis/Grocery/Groceryreport";
import Foodterms from "./Component/Modules/TermsAndConditions/Food/Foodterms";
import Termssidbar from "./Component/Modules/TermsAndConditions/Termssidbar";
import Cateringcare from "./Component/Modules/Customercaremanagment/Caterings/Cateringcare";
import Grocerycare from "./Component/Modules/Customercaremanagment/Grocery/Grocerycare";
import Logisticscare from "./Component/Modules/Customercaremanagment/Logistics/Logisticscare";
import Cateringterms from "./Component/Modules/TermsAndConditions/Caterings/Cateringterms";
import Grocerterm from "./Component/Modules/TermsAndConditions/Grocery/Grocerterm";
import Logisticsterms from "./Component/Modules/TermsAndConditions/Logistics/Logisticsterms";
import Controlmanagmentpage from "./Component/Modules/Controlmanagment/Controlpage/Controlmanagmentpage";
import Cateringmenu from "./Component/Modules/Menumanagment/Cateringsmenu/Cateringmenu";
import Controllmanagmentdata from "./Component/Modules/Controlmanagment/Controlpage/Controllmanagmentdata"
import Termsandconditions from "./Component/Termsandconditions";
import Controllmanagmentsuper from "./Component/Modules/Controlmanagment/Controlpage/Controllmanagmentsuper";
import ProtectedRoute from "./Component/ProtectedRoute";
import FoodSupportSystem from "./Component/Modules/Supportsystem/FoodSupportSystem";
import Supportsytemsidebar from "./Component/Modules/Supportsystem/Supportsytemsidebar";
import Foodnotification from "./Component/Modules/Notifications/Food/Foodnotification";
import Foodnotificationsidebar from "./Component/Modules/Notifications/Foodnotificationsidebar";
import Foodlegalcompliance from "./Component/Modules/Legalcompliance/Food/Foodlegalcompliance";
import Legalcompliancesidebar from "./Component/Modules/Legalcompliance/Legalcompliancesidebar";
import Fooddashboard from "./Component/Modules/Dashboard/Food/Fooddashbord";
import Foodmenu from "./Component/Modules/Menumanagment/Foodmenu";
import Menumanagementsidebar from "./Component/Modules/Menumanagment/Menumanagementsidebar";
import Foodclientmanagement from "./Component/Modules/Clientmanagment/Food/Foodclientmanagement";
import Ridersmanagment from "./Component/Modules/Clientmanagment/Food/Ridersmanagment";
import Foodordermanagement from './Component/Modules/Ordermanagment/Food/Foodordermanagement';
import Foodmenumanagement from './Component/Modules/Menumanagment/Cateringsmenu/Foodmenumanagement';
import Foodsettingmanagement from './Component/Modules/Accounthistorymanagment/Food/Foodsettingmanagement';
import Foodaccountmanagement from './Component/Modules/Accountsandhistory/Food/Foodaccountmanagement';
import Foodreportmanagement from './Component/Modules/ReportandAnalysis/Food/Foodreportmanagement';
import Controlllanding from './Component/Modules/Controlmanagment/Controlllanding';
import Teamlanding from './Component/Modules/Accounthistorymanagment/Food/Teamlanding';
import Superadmindashbord from './Component/Superadmindashbord';
import SalesManagment from './Component/Modules/SalesCRM/SalesManagment';

import FoodOrderDetailsPage from "./Component/Modules/Ordermanagment/Food/FoodOrderDetailsPage";


const Layout = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Routes without any layout (like auth pages)
  const noLayoutRoutes = ["/", "/signup", "/resetpassword"];
  if (noLayoutRoutes.includes(path)) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
      </Routes>
    );
  }


  const layoutMap = [

    {
      paths: ["/foodterms", "/cateringterms", "/grocerterm", "/logisticsterms"],
      Navbar: <NavBars />,
      Sidebar: <Termssidbar />
    },

    {
      paths: ["/termsandconditionspage"],

    },

  ];

  const matchedLayout = layoutMap.find(layout =>
    layout.paths.includes(path)
  );

  // const NavbarComponent = matchedLayout ? matchedLayout.Navbar : <NavBars />;
  const SidebarComponent = matchedLayout ? matchedLayout.Sidebar : <Sidebar />;

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* {NavbarComponent} */}
      <div style={{ display: "flex", flexGrow: 1 }}>
        {SidebarComponent}
        <div style={{ flexGrow: 1, }}>
          <Routes>
            {/* Main App Routes */}
            <Route path="/homes" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/bannerimages" element={<ProtectedRoute><Bannerimages /></ProtectedRoute>} />

            {/* Business Routes */}
            {/* ====================================== All the Compoents ================================================================== */}

            <Route path="/foodsubscription" element={<ProtectedRoute><Foodsubscription /></ProtectedRoute>} />
            <Route path="/grocerysubscription" element={<ProtectedRoute><Grocerysubscription /></ProtectedRoute>} />
            <Route path="/cateringsubscription" element={<ProtectedRoute><Cateringsubscription /></ProtectedRoute>} />
            <Route path="/logisticssubscription" element={<ProtectedRoute><Logisticssubscription /></ProtectedRoute>} />
            <Route path="/eventssubscription" element={<ProtectedRoute><Eventssubscription /></ProtectedRoute>} />
            <Route path="/foodclient" element={<ProtectedRoute><FoodClient /></ProtectedRoute>} />
            <Route path="/cateringclient" element={<ProtectedRoute><Cateringclient /></ProtectedRoute>} />
            <Route path="/cateringregisteterd" element={<ProtectedRoute><Cateringregisteterd /></ProtectedRoute>} />
            <Route path="/groceryclientmanagement" element={<ProtectedRoute><Groceryclientmanagement /></ProtectedRoute>} />
            <Route path="/logisticsclients" element={<ProtectedRoute><Logisticsclients /></ProtectedRoute>} />
            <Route path="/eventclient" element={<ProtectedRoute><Eventclient /></ProtectedRoute>} />
            <Route path="/foodorder" element={<ProtectedRoute><Foodorder /></ProtectedRoute>} />
            <Route path="/eventorder" element={<ProtectedRoute><Eventorder /></ProtectedRoute>} />
            <Route path="/cateringordersdata" element={<ProtectedRoute><Cateringorders /></ProtectedRoute>} />
            <Route path="/groceryorder" element={<ProtectedRoute><Groceryorder /></ProtectedRoute>} />
            <Route path="/logisticsandservices" element={<ProtectedRoute><Logisticsandservices /></ProtectedRoute>} />
            <Route path="/userdetails" element={<ProtectedRoute><Userdetails /></ProtectedRoute>} />
            <Route path="/cateringuserdetailsdata" element={<ProtectedRoute><Userdetailsdata /></ProtectedRoute>} />
            <Route path="/groceryuserdetails" element={<ProtectedRoute><Groceryuserdetails /></ProtectedRoute>} />
            <Route path="/logisticsuserdetails" element={<ProtectedRoute><Logisticsuserdetails /></ProtectedRoute>} />
            <Route path="/foodsetingspage" element={<ProtectedRoute><Foodsetingspage /></ProtectedRoute>} />
            <Route path="/eventsetingspage" element={<ProtectedRoute><Eventsetingspage /></ProtectedRoute>} />
            {/* <Route path="/foodbillingandsetup" element={<Foodsetingspage />} /> */}
            <Route path="/cateringsetiingspage" element={<ProtectedRoute><Cateringsetiingspage /></ProtectedRoute>} />
            <Route path="/groceriessettings" element={<ProtectedRoute><Groceriessettings /></ProtectedRoute>} />
            <Route path="/logisticssettings" element={<ProtectedRoute><Logisticssettings /></ProtectedRoute>} />
            <Route path="/foodaccounts" element={<ProtectedRoute><Foodaccounts /></ProtectedRoute>} />
            <Route path="/eventaccounts" element={<ProtectedRoute><Eventaccounts /></ProtectedRoute>} />
            <Route path="/cateringsaccounts" element={<ProtectedRoute><CateringsAccounts /></ProtectedRoute>} />
            <Route path="/groceryaccounts" element={<ProtectedRoute><GroceryAccounts /></ProtectedRoute>} />
            <Route path="/logisticsaccounts" element={<ProtectedRoute><LogisticsAccounts /></ProtectedRoute>} />
            <Route path="/foodpramotions" element={<ProtectedRoute><FoodPramotions /></ProtectedRoute>} />
            <Route path="/eventpramotions" element={<ProtectedRoute><EventPramotions /></ProtectedRoute>} />
            <Route path="/promotionscaterings" element={<ProtectedRoute><Promotionscaterings /></ProtectedRoute>} />
            <Route path="/promotionsgrocery" element={<ProtectedRoute><Promotionsgrocery /></ProtectedRoute>} />
            <Route path="/logisticspromotions" element={<ProtectedRoute><Logisticspromotions /></ProtectedRoute>} />
            <Route path="/foodcare" element={<ProtectedRoute><Foodcare /></ProtectedRoute>} />
            <Route path="/eventcare" element={<ProtectedRoute><Eventcare /></ProtectedRoute>} />
            <Route path="/cateringcare" element={<ProtectedRoute><Cateringcare /></ProtectedRoute>} />
            <Route path="/grocerycare" element={<ProtectedRoute><Grocerycare /></ProtectedRoute>} />
            <Route path="/foodreports" element={<ProtectedRoute><Foodreports /></ProtectedRoute>} />
            <Route path="/eventreports" element={<ProtectedRoute><Eventreports /></ProtectedRoute>} />
            <Route path="/foodterms" element={<ProtectedRoute><Foodterms /></ProtectedRoute>} />
            <Route path="/logisticscare" element={<ProtectedRoute><Logisticscare /></ProtectedRoute>} />
            <Route path="/cateringterms" element={<ProtectedRoute><Cateringterms /></ProtectedRoute>} />
            <Route path="/grocerterm" element={<ProtectedRoute><Grocerterm /></ProtectedRoute>} />
            <Route path="/logisticsterms" element={<ProtectedRoute><Logisticsterms /></ProtectedRoute>} />
            <Route path="/cateringreports" element={<ProtectedRoute><CateringReports /></ProtectedRoute>} />
            <Route path="/groceryreport" element={<ProtectedRoute><Groceryreport /></ProtectedRoute>} />
            <Route path="/logisticsreports" element={<ProtectedRoute><Logisticsreports /></ProtectedRoute>} />
            <Route path="/controlmanagmentpage" element={<ProtectedRoute><Controlmanagmentpage /></ProtectedRoute>} />
            <Route path="/cateringmenu" element={<ProtectedRoute><Cateringmenu /></ProtectedRoute>} />
            <Route path="/controllmanagmentdata" element={<ProtectedRoute><Controllmanagmentdata /></ProtectedRoute>} />
            <Route path="/termsandconditionspage" element={<ProtectedRoute><Termsandconditions /></ProtectedRoute>} />
            <Route path="/controllmanagmentsuper" element={<ProtectedRoute><Controllmanagmentsuper /></ProtectedRoute>} />
            <Route path="/foodSupportSystem" element={<ProtectedRoute><FoodSupportSystem /></ProtectedRoute>} />
            <Route path="/foodnotification" element={<ProtectedRoute><Foodnotification /></ProtectedRoute>} />
            <Route path="/foodlegalcompliance" element={<ProtectedRoute><Foodlegalcompliance /></ProtectedRoute>} />
            <Route path="/fooddashboard" element={<ProtectedRoute><Fooddashboard /></ProtectedRoute>} />
            <Route path="/foodmenu" element={<ProtectedRoute><Foodmenu /></ProtectedRoute>} />
            <Route path="/foodclientmanagement" element={<ProtectedRoute><Foodclientmanagement /></ProtectedRoute>} />
            <Route path="/foodordermanagement" element={<ProtectedRoute><Foodordermanagement /></ProtectedRoute>} />
            <Route path="/foodmenumanagement" element={<ProtectedRoute><Foodmenumanagement /></ProtectedRoute>} />
            <Route path="/foodsettingmanagement" element={<ProtectedRoute><Foodsettingmanagement /></ProtectedRoute>} />
            <Route path="/foodaccountmanagement" element={<ProtectedRoute><Foodaccountmanagement /></ProtectedRoute>} />
            <Route path="/foodreportmanagement" element={<ProtectedRoute><Foodreportmanagement /></ProtectedRoute>} />
            <Route path="/controlllanding" element={<ProtectedRoute><Controlllanding /></ProtectedRoute>} />
            <Route path="/teamlanding" element={<ProtectedRoute><Teamlanding /></ProtectedRoute>} />
            <Route path="/Superadmindashbord" element={<ProtectedRoute><Superadmindashbord /></ProtectedRoute>} />
            <Route path="/ridersmanagement" element={<ProtectedRoute><Ridersmanagment /></ProtectedRoute>} />
            <Route path="/salesmanagement" element={<ProtectedRoute> <SalesManagment /> </ProtectedRoute>} />
            <Route path="/admin/orders/details/:orderId" element={<ProtectedRoute> <FoodOrderDetailsPage /> </ProtectedRoute>} />










          </Routes>
        </div>
      </div>
    </div >
  );
};

export default Layout;
